import store from '../store/Store'
import actionTypes from '../actionTypes/actionTypes'
import config from '../config/Config'

const URL = config.PRODUCTION ? config.HTTP + config.API_PRODUCTION_HOST + ':' + config.API_PRODUCTION_PORT + config.API_IMAGE : config.HTTP + config.LOCAL_HOST + ':' + config.API_LOCAL_PORT + config.API_IMAGE

// console.log(URL)

async function uploadImage(data) {
	console.log(data)

	const res = await fetch(URL, {
		method: "POST",
		mode: "cors",
		headers: {
		  'Accept': 'application/json',
		  'Access-Control-Allow-Origin': '*'
		},
		body: data
	})

	return await res.json()
}

const uploadActions = {
	uploadImage
}

export default uploadActions;